<div class="mx-auto">
  <!-- Cabecera con mejor alineación y espaciado -->
  <app-header></app-header>
  <div class="flex min-h-screen relative main-content">
    <!-- Menú Lateral -->
    <div
      class="sidebar absolute left-0 w-80 md:w-56 h-screen  overflow-y-auto  shadow-lg z-10 bg-gray-100 transition-all ease-in-out duration-300 inset-y-0"
      [ngClass]="{'closed': !(sidebarService.isOpen$ | async), 'active': isSidebarActive}">

      <!-- Sidebar Content -->
      <div class="flex flex-col h-full p-6 space-y-4  ">
        <!-- Logo o Encabezado -->
        <div class="flex items-center justify-center mt-24">
          <img src="https://www.up-spain.com/wp-content/uploads/2022/03/up-spain.png" class="h-16 w-auto"
            alt="UP Spain">
        </div>

        <!-- Menú Items -->

        <div class="space-y-2">
          <!-- Menú Item: Facturación -->
          <div class="group" *ngIf="['ROLE_ADMIN', 'ROLE_CONSULTANT'].includes(userRole)"
            (click)="toggleBillingSubMenu()">
            <div
              class="flex items-center p-3 rounded-md bg-orange-400 hover:bg-orange-500 transition-colors duration-200 ease-in-out sidebar-button">
              <div class="flex items-center">
                <i class="fas fa-file-invoice-dollar text-white sidebar-icon"></i>
                <span class="ml-1 text-white sidebar-text ">Facturación</span>
                <i class="fas fa-chevron-down ml-1 text-white"></i>
              </div>
            </div>
            <!-- Submenu Items: Facturación -->
            <div class="pl-4 mt-2 space-y-2" [ngClass]="{'hidden': !isBillingSubMenuOpen}">
              <a [routerLink]="'billing-process'" *ngIf="['ROLE_ADMIN'].includes(userRole)"
                class="flex items-center p-3 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-receipt text-xl sidebar-icon text-white"></i>
                <span class="ml-2 text-sm text-white sidebar-subitem-text">Procesos de Facturación</span>
              </a>
              <a [routerLink]="'activity-log'"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-calendar-alt text-lg text-white"></i>
                <span class="ml-2 text-sm text-white sidebar-subitem-text">Registro de eventos</span>
              </a>
              <a [routerLink]="'client-codes'" *ngIf="['ROLE_ADMIN'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-search-dollar text-lg text-white"></i>
                <span class="ml-2 text-sm text-white sidebar-subitem-text">Consultar código</span>
              </a>
              <a [routerLink]="'download'" *ngIf="['ROLE_ADMIN'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fa-solid fa-download  text-lg text-white"></i>
                <span class="ml-2 text-sm text-white sidebar-subitem-text">Descargar factura</span>
              </a>
              <a [routerLink]="'bills-list'" *ngIf="['ROLE_ADMIN', 'ROLE_CONSULTANT'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-file-invoice-dollar text-lg text-white"></i>
                <span class="ml-2 text-sm text-white sidebar-subitem-text">Albaranes</span>
              </a>
              <a [routerLink]="'biller'" *ngIf="['ROLE_ADMIN'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-paper-plane text-lg text-white"></i>
                <span class="ml-2 text-sm text-white sidebar-subitem-text">Enviar un proveedor</span>
              </a>
              <a [routerLink]="'billing'" *ngIf="['ROLE_ADMIN'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-users text-lg text-white"></i>
                <span class="ml-2 text-sm text-white sidebar-subitem-text">Enviar todos</span>
              </a>
              <a [routerLink]="'billing-failed'" *ngIf="['ROLE_ADMIN'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-exclamation-triangle text-lg text-white"></i>
                <span class="ml-1 text-xs text-white sidebar-subitem-text">Proveedores
                  pendientes</span>
              </a>

            </div>

          </div>

          <!-- Menú Item: CRM -->
          <div class="group" *ngIf="['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_CONSULTANT'].includes(userRole)"
            (click)="toggleCrmSubMenu()">
            <div
              class="flex items-center  p-3 rounded-md bg-orange-400 hover:bg-orange-500 transition-colors duration-200 ease-in-out sidebar-button">
              <div class="flex items-center">
                <i class="fas fa-user-friends text-white sidebar-icon"></i>
                <span class="ml-1 text-white sidebar-text">CRM</span>
                <i class="fas fa-chevron-down ml-1 text-white"></i>
              </div>
            </div>
            <!-- Submenú Items: CRM -->
            <div class="pl-4 mt-2 space-y-2" [ngClass]="{'hidden': !isCrmSubMenuOpen}">
              <a [routerLink]="['/home/crm/client-form']" *ngIf="['ROLE_CRM', 'ROLE_ADMIN'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-user-plus text-lg text-white"></i>
                <span class="ml-1 text-sm text-white sidebar-subitem-text">Crear cliente para facturador</span>
              </a>
              <a [routerLink]="['/home/crm/create-fee']" *ngIf="['ROLE_CRM', 'ROLE_ADMIN'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-dollar-sign text-lg text-white"></i>
                <span class="ml-1 text-sm text-white sidebar-subitem-text">Crear tarifa para facturador</span>
              </a>
              <a [routerLink]="['/home/crm/bulk-clients-list']" *ngIf="['ROLE_CRM', 'ROLE_ADMIN'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fa-solid fa-cloud-arrow-up text-lg text-white"></i>
                <span class="ml-1 text-sm text-white sidebar-subitem-text">Carga masiva de clientes</span>
              </a>
              <a [routerLink]="['/home/crm/clients-list']"
                *ngIf="['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_CONSULTANT'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-file-invoice text-lg text-white"></i>
                <span class="ml-1 text-sm text-white sidebar-subitem-text">Obtener clientes</span>
              </a>
              <a [routerLink]="['/home/crm/contacts-list']"
                *ngIf="['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_CONSULTANT'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fa-regular fa-address-book text-lg text-white"></i>
                <span class="ml-1 text-sm text-white sidebar-subitem-text">Obtener contactos</span>
              </a>
              <a [routerLink]="['/home/crm/list-fees']"
                *ngIf="['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_CONSULTANT'].includes(userRole)"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-file-invoice text-lg text-white"></i>
                <span class="ml-1 text-sm text-white sidebar-subitem-text">Obtener tarifas desde facturador</span>
              </a>
              <a [routerLink]="'master-billing'"
                *ngIf="['ROLE_ADMIN', 'ROLE_CONSULTANT', 'ROLE_CRM'].includes(userRole)"
                class="flex items-center p-3 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-receipt text-xl text-white"></i>
                <span class="ml-1 text-sm text-white sidebar-subitem-text">Concepto de facturación</span>
              </a>
              <a [routerLink]="['/home/crm/bulk-create']"
                *ngIf="['ROLE_ADMIN', 'ROLE_CONSULTANT', 'ROLE_CRM'].includes(userRole)"
                class="flex items-center p-3 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fa-solid fa-cloud-arrow-up text-lg text-white"></i>
                <span class="ml-1 text-sm text-white sidebar-subitem-text">Carga masiva de tarifas desde CSV</span>
              </a>
            </div>
          </div>

          <!-- Menú Item: Proveedores -->
          <div class="group" (click)="toggleProviderSubMenu()"
            *ngIf="['ROLE_ADMIN', 'ROLE_CONSULTANT'].includes(userRole)">
            <div
              class="flex items-center p-3 rounded-md bg-orange-400 hover:bg-orange-500 transition-colors duration-200 ease-in-out sidebar-button">
              <div class="flex items-center">
                <i class="fas fa-building text-white sidebar-icon"></i>
                <span class="ml-1 text-sm text-white sidebar-text">Proveedores</span>
                <i class="fas fa-chevron-down ml-1 text-white"></i>
              </div>
            </div>
            <!-- SUBMENU PROVEEDORES -->
            <div class="pl-4 mt-2 space-y-2" [ngClass]="{'hidden': !isProviderSubMenuOpen}">
              <a [routerLink]="['/home/providers']"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-file-invoice text-lg text-white"></i>
                <span class="ml-1 text-sm text-white sidebar-subitem-text">Obtener proveedores</span>
              </a>
              <a [routerLink]="['/home/providers-range-date']"
                class="flex items-center p-2 rounded-md transition-colors duration-200 ease-in-out bg-orange-500 hover:bg-orange-600">
                <i class="fas fa-calendar-alt text-lg text-white"></i>
                <span class="ml-1 text-sm text-white sidebar-subitem-text">Datos de facturación de proveedor</span>
              </a>
            </div>
          </div>

          <!-- Menú Item: Usuarios -->
          <div class="group" *ngIf="['ROLE_ADMIN', 'ROLE_CONSULTANT'].includes(userRole)">
            <a [routerLink]="'users'"
              class="flex items-center p-3 rounded-md transition-colors duration-200 ease-in-out bg-orange-400 hover:bg-orange-500">
              <div class="flex items-center">
                <i class="fas fa-users text-white sidebar-icon"></i>
                <span class="ml-3  text-white sidebar-text">Usuarios</span>
              </div>
            </a>
          </div>

        </div>
      </div>
    </div>

    <div class="flex-1 transition-all duration-300 mt-32 " [ngClass]="{
         'm-[32px] ': (sidebarService.isOpen$ | async),
         'm-32 ': !(sidebarService.isOpen$ | async)
       }">
      <router-outlet></router-outlet>
    </div>


  </div>


</div>